import { getFacilitiesCompleted, getFacilitiesError } from "../../../actions/choiceLists";
import { getCodeMetadata } from "../../../actions/codeMetadata";
import { addErrorsAction } from "../../../actions/errors";
import { choiceListsAPI } from "../../../services/choiceLists";
import { parseServiceErrors } from "../../../services/encounter/serviceErrors";
import { systemPreferencesAPI } from "../../../services/systemPreferences";
import {
  getRemoteServicesSettingsActionCompleted,
  getRemoteServicesSettingsActionError,
} from "../../SystemPreferences/actions/remoteServicesSettingsAction";

import type { IdDescriptionBase } from "../../../models/patientEncounter";
import type { State } from "../../../reducers";

// prepare all storages to open encounter:
// - load code metadata if it is not loaded
// - load facilities
// - load remote services settings
export const prepareToOpenEncounter = (
  dispatch,
  codeMetadataInitialized: boolean,
  loadedFacilities?: IdDescriptionBase[],
) => {
  const initCalls: Promise<any>[] = [];

  initCalls.push(
    getCodeMetadata(dispatch, codeMetadataInitialized).then((loaded) => ({
      codeMetadata: loaded,
    })),
  );

  initCalls.push(
    getFacilities(dispatch, loadedFacilities).then((facilities) => ({
      facilities,
    })),
  );

  initCalls.push(dispatch(loadRemoteServicesSettingsIfNeeded));

  return Promise.all(initCalls).then((results) => {
    // it is necessary to return fresh facilities list. find it within responses
    const allFacilities = results.find((item) => item.facilities);
    return allFacilities ? allFacilities.facilities : [];
  });
};

const loadRemoteServicesSettingsIfNeeded = async (dispatch, getState: () => State) => {
  const state = getState();
  if (state.systemPreferences.remoteServicesSettings.ConcurrencyVersion) {
    return;
  }

  try {
    const settings = await systemPreferencesAPI.getRemoteServicesSettings();
    dispatch(getRemoteServicesSettingsActionCompleted(settings));
  } catch (reason) {
    const errors = parseServiceErrors(reason, "Error Retrieving Remote Services Settings");
    dispatch(addErrorsAction(errors));
    dispatch(getRemoteServicesSettingsActionError(reason));
  }
};

const getFacilities = (dispatch, loadedFacilities?: IdDescriptionBase[]) => {
  // ability to use already loaded data
  if (loadedFacilities?.length) {
    return Promise.resolve().then(() => loadedFacilities);
  }

  return choiceListsAPI
    .getFacilities()
    .then((facilities) => {
      dispatch(getFacilitiesCompleted(facilities));
      if (!facilities || facilities.length === 0) {
        dispatch(getFacilitiesError("No Facilities"));
      }

      return facilities;
    })
    .catch(() => {
      dispatch(getFacilitiesError("Facilities fetch error"));
      throw new Error("Facilities fetch error");
    });
};
